import { render, staticRenderFns } from "./RouterBackLink.vue?vue&type=template&id=694489d6&lang=pug&"
import script from "./RouterBackLink.vue?vue&type=script&lang=js&"
export * from "./RouterBackLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports